/* eslint-disable react-hooks/rules-of-hooks */
import { useResponsive, TResponsiveBreakpoint } from ".";

type ResponsiveCondition = {
  [breakpoint in TResponsiveBreakpoint]?: unknown;
};

interface ResponsiveProp {
  up?: ResponsiveCondition;
  down?: ResponsiveCondition;
}

export default function useResponsiveProp<T = unknown>(
  prop: ResponsiveProp | T,
  defaultProp: T | null = null
): T | null {
  let value: T | ResponsiveProp | null = prop;

  if (prop && typeof prop === "object" && ("up" in prop || "down" in prop)) {
    for (const condition of ["up", "down"] as const) {
      const breakpoints = prop[condition];
      if (breakpoints) {
        for (const breakpoint in breakpoints) {
          const typedBreakpoint = breakpoint as TResponsiveBreakpoint;
          if (useResponsive(condition, typedBreakpoint)) {
            value = breakpoints[typedBreakpoint] as T;
          }
        }
      }
    }
  }

  value = (value as T | null) ?? defaultProp;

  return value;
}

export { useResponsiveProp };
